import {
  Button,
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  TextField,
} from "@mui/material";
import { errorMessage } from "components/AlertComponent";
import { setAction } from "context";
import { useMaterialUIController } from "context";
import { getFilesWithNationalCode } from "controllers/FileController";
import { getFilesForuser } from "controllers/FileController";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import AdapterJalali from "@date-io/date-fns-jalali";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { setFileVisible } from "controllers/FileController";
import { StoreFile } from "controllers/FileController";
import { insertPersonalPageAnswer } from "controllers/PageController";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import getText from "Translator";
import { getPatientDetails } from "controllers/FileController";
import LoadingOverlay from "react-loading-overlay";

let patientFromServer;
let menu;
export default function NewPatientComponent(props) {
  const [nationalCode, setNationalCode] = useState("");
  const [mode, setMode] = useState(0);
  const [nationalCodeList, setNationalCodeList] = useState([]);
  const [patientName, setPatientName] = useState("");
  const [patientFamily, setPatientFamily] = useState("");
  const [birthYear, setBirthYear] = useState();
  const [reload, setReload] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [patientExist, setPatientExist] = useState(true);
  const [focus, setFocus] = useState("nationalcode");
  const [controller, dispatch] = useMaterialUIController();
  const [patientDetails, setPatientDetails] = useState({});
  const navigate = useNavigate();

  const {
    file,
    from,
    closeHandle,
    selectedItem,
    createMenu,
    serachIconHandler,
    handleSearch,
  } = props;
  const getMenu = async () => {
    try {
      menu = await localStorage.getItem("$menu");
      if (menu) {
        menu = JSON.parse(menu);
      }
    } catch (err) {
      errorMessage(err, "fa");
    }
  };
  const createNewPatient = async () => {
    try {
      let savedFile;
      let file = "";
      if (file) {
        file = file;
      }
      let newFile = {
        file,
        headline: menu.headline,
        capsule: menu.capsule,
        patientName,
        patientFamily,
        title: menu.title,
        showInForum: false,
        summary: "",
        showInForumAdmin: false,
        sendToServer: false,
        myquestion: "",
        sendToForumDate: new Date(),
        patientNationalCode: nationalCode,
        visible: true,
        birthDate: birthYear,
        gender: -1,
        fatherName: "",
        from: from,
        visitedpageslist: [],
        Account: controller.id,
      };
      setLoading(true);
      savedFile = await StoreFile(newFile, controller);

      setLoading(false);
      if (savedFile.success) {
        let datas = [
          {
            id: "5f87e27c7d51e72a84dc57d0", //1182
            answer: patientDetails.gender,
            file: savedFile.data._id,
            nationalCode: nationalCode,
          },
          {
            id: "5f87e27c7d51e72a84dc5840", //1183
            answer: patientDetails.age,
            file: savedFile.data._id,
            nationalCode: nationalCode,
          },
          {
            id: "5f87e27c7d51e72a84dc579d", //1267
            answer: patientDetails.weight,
            file: savedFile.data._id,
            nationalCode: nationalCode,
          },
          {
            id: "5f87e27c7d51e72a84dc5772", //1268
            answer: patientDetails.height,
            file: savedFile.data._id,
            nationalCode: nationalCode,
          },
          {
            id: "5f87e27b7d51e72a84dc55a3", //1761
            answer: patientDetails.phone,
            file: savedFile.data._id,
            nationalCode: nationalCode,
          },
        ];
        setLoading(true);
        let newData = {
          file: savedFile.data._id,
          nationalCode,
          datas,
        };
        let savedAnswers = await insertPersonalPageAnswer(newData, controller);
        setLoading(true);

        console.log("sssssssss", savedAnswers);
        if (savedAnswers.success) {
          Swal.fire({
            text: getText("alertsuccess", "fa"),
            position: "bottom-end",
            background: "#03fca1",
            showConfirmButton: false,
            timer: 1500,
          });
          let menuDB = await localStorage.getItem("$menu");
          if (menuDB) {
            menuDB = JSON.parse(menuDB);
            menuDB.file = savedFile.data._id;
            menuDB.nationalCode = nationalCode;
            menuDB.birthYear = birthYear;
            menuDB.showResultOfFile = false;
            menuDB.isMyFile = true;
            menuDB.limitedFile = false;
            menuDB.formType = 1;
            menuDB.from = "menu";
            menuDB.visitedpageslist = [];
            await localStorage.setItem("$menu", JSON.stringify(menuDB));
          }
        } else {
          Swal.fire({
            text: savedAnswers.message,
            position: "bottom-end",
            background: "#f1b3af",
            showConfirmButton: false,
            timer: 2500,
          });
        }
      } else {
        Swal.fire({
          text: savedFile.message,
          position: "bottom-end",
          background: "#f1b3af",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (err) {
      setLoading(false);
      errorMessage(err, "fa");
    }
  };
  const startPage = async () => {
    try {
      let savedFile;
      if (!menu) {
        await getMenu();
      }

      if (nationalCode.trim() === "") {
        Swal.fire({
          text: "لطفا کد ملی را وارد نمایید",
        });
        return;
        let newFile = {
          headLine: menu.headline,
          capsule: menu.capsule,
          account: controller.id,
          patientName: patientName,
          patientFamily: patientFamily,
          title: menu.title,
          showInForum: false,
          summary: "",
          showInForumAdmin: false,
          sendToServer: false,
          myquestion: "",
          sendToForumDate: new Date(),
          patientNationalCode: nationalCode,
          visible: true,
          birthDate: birthYear,
          gender: 0,
          fatherName: "",
          from: "list",
        };
        savedFile = await StoreFile(newFile, controller);

        if (savedFile.success) {
          let menuDB = await localStorage.getItem("$menu");
          if (menuDB) {
            menuDB = JSON.parse(menuDB);

            menuDB.file = savedFile.data._id;
            menuDB.nationalCode = "";
            menuDB.birthYear = "";
            menuDB.showResultOfFile = false;
            menuDB.isMyFile = true;
            menuDB.limitedFile = false;
            menuDB.formType = 1;
            menuDB.from = "menu";
            menuDB.visitedpageslist = [];
            await localStorage.setItem("$menu", JSON.stringify(menuDB));
          }
        } else {
          Swal.fire({
            text: getText("warningalert", "fa"),
            position: "bottom-end",
            background: "#f1b3af",
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      } else {
        if (nationalCode !== "") {
          //
          if (
            nationalCode.length !== 10 ||
            !birthYear ||
            patientName.length < 3 ||
            patientFamily.length < 3  
             
          ) {
            Swal.fire({
              title: getText("warning", "fa"),
              html: getText("validatenewpatient", "fa"),
              confirmButtonText: getText("ok", "fa"),
            });
            return;
          }
        }
        // if (birthYear.length !== 4) {
        //     Swal.fire({
        //         title: getText('warning', "fa"),
        //         text: getText('insertbirthyear', "fa"),
        //         confirmButtonText: getText('ok', "fa"),

        //     });
        //     return;
        // }
        // if (patientName.length < 2) {
        //     Swal.fire({
        //         title: getText('warning', "fa"),
        //         text: getText('inserfirstnamealert', "fa"),
        //         confirmButtonText: getText('ok', "fa"),

        //     });
        //     return;
        // }
        // if (patientFamily.length < 2) {
        //     Swal.fire({
        //         title: getText('warning', "fa"),
        //         text: getText('inserlastnamealert', "fa"),
        //         confirmButtonText: getText('ok', "fa"),

        //     });
        //     return;
        // }

        if (!patientExist) {
          await createNewPatient();
        } else {
          if (mode === 1 || mode === 4) {
            await createNewPatient();
          } else {
            closeHandle();
          }
          // if (mode === 1) {

          //     let add = await addUserToFile(nationalCode, menu.capsule, controller);
          //     if (!add.success) {
          //         Swal.fire({
          //             title: getText('warning', "fa"),
          //             text: add.message,
          //             confirmButtonText: getText('ok', "fa"),

          //         });

          //         return;
          //     }
          //     else {
          //         let menuDB = await localStorage.getItem("$menu");
          //         menuDB = JSON.parse(menuDB)
          //         menuDB.file = add.file;
          //         menuDB.nationalCode = nationalCode;
          //         menuDB.birthYear = birthYear;
          //         menuDB.showResultOfFile = false;
          //         await localStorage.setItem("$menu", JSON.stringify(menuDB));
          //     }
          // }
          // else if (mode === 4) {

          // await createNewPatient();

          //}
        }
      }

      //props.menuClickHandler

      if (from !== "save") {
        navigate("/pageview");
      }
      closeHandle();
    } catch (err) {
      setLoading(false);
      errorMessage(err, "fa");
    }
  };
  const getnationalCodes = async (search) => {
    try {
      if (search.length !== 10) {
        setBirthYear("");
        setPatientName("");
        setPatientFamily("");
        setPatientDetails({
          gender: "",
          age: "",
          weight: "",
          height: "",
          phone: "",
        });
        setPatientExist(true);
      }
      if (search.length > 4 && search.length < 10) {
        let filelist = [];
        let res = await getFilesWithNationalCode({ search }, controller);
        if (res.success) {
          setNationalCodeList(res.data);
        } else {
          Swal.fire({
            title: getText("warning", "fa"),
            text:
              getText("probleminproccess", "fa") +
              "\n\n" +
              getText("checkintenetconnection", "fa"),
            confirmButtonText: getText("ok", "fa"),
          });
          setNationalCodeList([]);
        }
      } else {
        setNationalCodeList([]);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorMessage(err, "fa");
    }
  };
  const processNationalCode = async (text) => {
    console.log(text);
    try {
      setLoading(true);
      if (!menu) {
        await getMenu();
      }
      let newData = {
        capsule: menu.capsule,
        text,
        search: text,
      };
      let res = await getFilesForuser(newData, controller);

      if (res.success) {
        if (res.incapsule) {
          //props.setFileListx(text);
          handleSearch(text);
          serachIconHandler(true, text);
          setPatientFamily("");
          setPatientName("");
          setNationalCode("");
          setBirthYear("");
          setPatientDetails({
            gender: "",
            age: "",
            weight: "",
            height: "",
            phone: "",
          });

          setLoading(false);
          closeHandle();
          Swal.fire({
            text: getText("existedCode", "fa"),
            showConfirmButton: false,
            position: "bottom-end",
            timerProgressBar: true,
            timer: 2000,

            // confirmButtonText: getText("ok", "fa"),
          });
          return;
        }
      }
      setLoading(true);
      let pData = {
        text,
        nationalCode: text,
        capsule: menu.capsule,
        birthYear,
      };
      patientFromServer = await getPatientDetails(pData, controller);

      console.log("asdasda", patientFromServer);
      if (!patientFromServer.success) {
        Swal.fire({
          title: getText("warning", "fa"),
          text: getText("probleminproccess", "fa"),
          confirmButtonText: getText("ok", "fa"),
        });

        setLoading(false);
        return;
      }

      if (patientFromServer.success) {
        setMode(patientFromServer.data.fileMode);
        if (
          patientFromServer.data.fileMode === 0 ||
          patientFromServer.data.fileMode === 3
        ) {
          setPatientExist(false);

          setLoading(false);
          return;
        } else {
          if (patientFromServer.data.fileMode === 2) {
            if (from === "save") {
              closeHandle();
              Swal.fire({
                title: getText("warning", "fa"),
                text: getText("existedCode", "fa"),
                confirmButtonText: getText("ok", "fa"),
              });
            } else {
              let newData = {
                file: patientFromServer.data._id,
                visible: true,
                isMyFile: true,
              };
              let visibleResult = await setFileVisible(
                newData,
                controller.token
              );
              if (visibleResult.success) {
                closeHandle();
                createMenu(
                  selectedItem,
                  controller.favorite,
                  patientFromServer.data.patientNationalCode
                );
                setAction(dispatch, "search");

                serachIconHandler(true, nationalCode);
              } else {
              }
            }

            setPatientName(patientFromServer.data.patientName);
            setPatientFamily(patientFromServer.data.patientFamily);
            // setBirthYear(
            //   (patientFromServer.data.birthDate + "").substring(0, 4)
            // );
            setBirthYear(patientFromServer.data.birthDate);
            setPatientDetails(patientFromServer.pg);
          } else if (patientFromServer.data.fileMode === 1 && from === "save") {
            setPatientName(patientFromServer.data.patientName);
            setPatientFamily(patientFromServer.data.patientFamily);
            // setBirthYear(
            //   (patientFromServer.data.birthDate + "").substring(0, 4)
            // );

            setBirthYear(patientFromServer.data.birthDate);
            setPatientDetails(patientFromServer.pg);
          } else {
            setPatientName(patientFromServer.data.patientName);
            setPatientFamily(patientFromServer.data.patientFamily);
            // setBirthYear(
            //   (patientFromServer.data.birthDate + "").substring(0, 4)
            // );

            setBirthYear(patientFromServer.data.birthDate);
            setPatientDetails(patientFromServer.pg);
          }
          setLoading(false);
        }
      }

      setLoading(false);
    } catch (err) {
      errorMessage(err, "fa");
    }
  };

  const convertToEnglishNumber = (str) => {
    // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
    var e = "۰".charCodeAt(0);
    str = str.replace(/[۰-۹]/g, function (t) {
      return t.charCodeAt(0) - e;
    });

    // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
    e = "٠".charCodeAt(0);
    str = str.replace(/[٠-٩]/g, function (t) {
      return t.charCodeAt(0) - e;
    });
    return str;
  };
  useEffect(() => {
    getMenu();
  }, []);
  return (
    <div
      style={{ padding: 10 }}
      className={"fa" === "en" ? "ltr" : "rtl"}
    >
      <LoadingOverlay
        active={controller.loading}
        styles={{
          position: "fixed",
          top: -100,
          left: -100,
          bottom: -100,
          right: -100,
        }}
        spinner
        text={getText("loading", "fa")}
      >
        <Grid container style={{ marginTop: 15 }}>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            style={{
              paddingRight: "fa" === "en" ? 15 : 0,
              paddingLeft: "fa" === "fa" ? 15 : 0,
            }}
          >
            <b> {getText("nationalcode", "fa")}</b>
            <br />
            <TextField
              label={getText("nationalcode", "fa") + "  *"}
              key="nationalcode"
              id="nationalcode"
              value={nationalCode}
              inputRef={(input) => {
                if (input != null && focus === "nationalcode") {
                  input.focus();
                }
              }}
              style={{
                backgroundColor:
                  nationalCode.length !== 10 ? "#ff9385" : "transparent",
              }}
              onFocus={() => {
                setFocus("nationalcode");
              }}
              fullWidth={true}
              variant="outlined"
              type="tel"
              maxLength={10}
              onChange={(event) => {
                let text = event.target.value;
                if (text.length > 10) {
                  text = text.substring(0, 10);
                }
                if (controller.id.length < 10) {
                  Swal.fire({
                    title: getText("warning", "fa"),
                    text: getText("firstregister", "fa"),
                    confirmButtonText: getText("ok", "fa"),
                  });

                  return;
                }
                setNationalCode(text.trim());
                if (text.length > 3 && text.length < 10) {
                  getnationalCodes(text);
                }
                if (text.length === 10) {
                  setNationalCodeList([]);
                  processNationalCode(text);
                  // setFocus("birthyear");
                } else {
                  setPatientExist(true);
                }
              }}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6}>
            <b> {getText("birthdate", "fa")}</b>
            <br />
            {controller.dateMode === "fa" && (
              <LocalizationProvider dateAdapter={AdapterJalali}>
                <DateTimePicker
                  fullWidth
                  
                  // label={getText("birthdate", "fa") + "  *"}
                  key="birthyear"
                  id="birthyear"
                  views={["day", "month", "year"]}
                   value={birthYear }
                  onChange={(value) => {
                    let nowY = moment(new Date(), "yyyy").year();
                    let birthY = moment(value, "yyyy").year();

                    let temp = patientDetails;
                    temp.age = nowY - birthY;

                    setBirthYear(value);
                    setPatientDetails(temp);
                    setReload(new Date());
                    setFocus("name");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth disabled />
                  )}
                />
              </LocalizationProvider>
            )}

            {/* <TextField
            InputLabelProps={{
              shrink: true,
            }}
            label={getText("birthyear", "fa") + "  *"}
            key="birthyear"
            id="birthyear"
            inputRef={(input) => {
              if (input != null && focus === "birthyear") {
                input.focus();
              }
            }}
            onFocus={() => {
              setFocus("birthyear");
            }}
            style={{
              backgroundColor:
                birthYear.length != 4 && nationalCode.length == 10
                  ? "#ff9385"
                  : "transparent",
            }}
            fullWidth={true}
            variant="outlined"
            type="tel"
            maxLength={10}
            onChange={(event) => {
              let text = event.target.value;
              if (text.length > 4) {
                text = text.substring(0, 4);
              }
              setBirthYear(text);
              if (text.length === 4) {
                let nowYear = moment(new Date(), "YYYY/MM/DD").year();

                if (controller.dateMode == "fa") {
                  nowYear = jMoment(new Date())
                    .format("jYYYY/jM/jD")
                    .substring(0, 4);

                  nowYear = convertToEnglishNumber(nowYear);
                }
                let temp = patientDetails;
                temp.age = parseInt(nowYear) - text;
                setPatientDetails(temp);
                setReload(new Date());
                setFocus("name");
              }
            }}
            value={birthYear}
          /> */}
          </Grid>
        </Grid>
        <Grid container style={{ marginTop: 15 }}>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            style={{
              paddingRight: "fa" === "en" ? 15 : 0,
              paddingLeft: "fa" === "fa" ? 15 : 0,
            }}
          >
            <b> {getText("name", "fa")}</b>
            <br />
            <TextField
              style={{
                backgroundColor:
                  patientName.length < 3 && nationalCode.length == 10
                    ? "#ff9385"
                    : "transparent",
              }}
              // label={getText("name", "fa") + "  *"}
              key="name"
              id="name"
              inputRef={(input) => {
                if (input != null && focus === "name") {
                  input.focus();
                }
              }}
              onFocus={() => {
                setFocus("name");
              }}
              fullWidth={true}
              variant="outlined"
              returnKeyType="next"
              disabled={patientExist}
              maxLength={10}
              onChange={(event) => {
                let text = event.target.value;
                setPatientName(text);
              }}
              value={patientName}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            <b> {getText("family", "fa")}</b>
            <br />
            <TextField
              key="family"
              id="family"
              inputRef={(input) => {
                if (input != null && focus === "family") {
                  input.focus();
                }
              }}
              onFocus={() => {
                setFocus("family");
              }}
              style={{
                backgroundColor:
                  patientFamily.length < 3 && nationalCode.length == 10
                    ? "#ff9385"
                    : "transparent",
              }}
              fullWidth={true}
              variant="outlined"
              disabled={patientExist}
              maxLength={10}
              onChange={(event) => {
                let text = event.target.value;
                setPatientFamily(text);
              }}
              value={patientFamily}
            />
          </Grid>
        </Grid>
        <div style={{ display: "none" }}>
          <Grid container style={{ marginTop: 15 }}>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                paddingRight: "fa" === "en" ? 15 : 0,
                paddingLeft: "fa" === "fa" ? 15 : 0,
              }}
            >
              {/* <b> {getText('age', "fa")}</b> */}
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                style={{
                  backgroundColor:
                    patientDetails.age + "" == "" && nationalCode.length == 10
                      ? "#ff9385"
                      : "transparent",
                }}
                label={getText("age", "fa") + " *"}
                key="age"
                id="age"
                inputRef={(input) => {
                  if (input != null && focus === "age") {
                    input.focus();
                  }
                }}
                onFocus={() => {
                  setFocus("age");
                }}
                fullWidth={true}
                variant="outlined"
                type="tel"
                disabled={true}
                maxLength={10}
                onChange={(event) => {
                  let temp = patientDetails;
                  temp.age = event.target.value;
                  setPatientDetails(temp);
                  setReload(new Date());
                }}
                value={patientDetails.age}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              {/* <b> {getText('gender', "fa")}</b> */}

              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                label={getText("gender", "fa") + " *"}
                key="gender"
                id="gender"
                inputRef={(input) => {
                  if (input != null && focus === "gender") {
                    input.focus();
                  }
                }}
                onFocus={() => {
                  setFocus("gender");
                }}
                style={{
                  backgroundColor:
                    patientDetails.gender + "" == "" &&
                    nationalCode.length == 10
                      ? "#ff9385"
                      : "transparent",
                }}
                fullWidth={true}
                variant="outlined"
                select
                disabled={patientExist}
                maxLength={10}
                onChange={(event) => {
                  let temp = patientDetails;
                  temp.gender = event.target.value;
                  setPatientDetails(temp);
                  setReload(new Date());
                }}
                value={patientDetails.gender + ""}
              >
                <MenuItem key="0" value="61f8d077379abf268c7c1849">
                  {getText("female", "fa")}
                </MenuItem>
                <MenuItem key="1" value="61f8d077379abf268c7c184a">
                  {getText("male", "fa")}
                </MenuItem>
              </TextField>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 15 }}>
            <Grid
              item
              xs={6}
              sm={6}
              md={6}
              style={{
                paddingRight: "fa" === "en" ? 15 : 0,
                paddingLeft: "fa" === "fa" ? 15 : 0,
              }}
            >
              {/* <b> {getText('height', "fa")}</b> */}
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                label={getText("height", "fa")}
                key="height"
                id="height"
                inputRef={(input) => {
                  if (input != null && focus === "height") {
                    input.focus();
                  }
                }}
                onFocus={() => {
                  setFocus("height");
                }}
                fullWidth={true}
                variant="outlined"
                type="tel"
                disabled={patientExist}
                maxLength={5}
                onChange={(event) => {
                  let temp = patientDetails;
                  temp.height = event.target.value;
                  setPatientDetails(temp);
                  setReload(new Date());
                }}
                value={patientDetails.height}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              {/* <b> {getText('weight', "fa")}</b> */}
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                label={getText("weight", "fa")}
                key="weight"
                id="weight"
                inputRef={(input) => {
                  if (input != null && focus === "weight") {
                    input.focus();
                  }
                }}
                onFocus={() => {
                  setFocus("weight");
                }}
                fullWidth={true}
                variant="outlined"
                type="tel"
                disabled={patientExist}
                maxLength={5}
                onChange={(event) => {
                  let temp = patientDetails;
                  temp.weight = event.target.value;
                  setPatientDetails(temp);
                  setReload(new Date());
                }}
                value={patientDetails.weight}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 15 }}>
            <Grid item xs={12} sm={12} md={12}>
              {/* <b> {getText('phone', "fa")}</b> */}

              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                label={getText("phone", "fa")}
                key="phone"
                id="phone"
                inputRef={(input) => {
                  if (input != null && focus === "phone") {
                    input.focus();
                  }
                }}
                onFocus={() => {
                  setFocus("phone");
                }}
                fullWidth={true}
                variant="outlined"
                type="tel"
                disabled={patientExist}
                maxLength={5}
                onChange={(event) => {
                  let temp = patientDetails;
                  temp.phone = event.target.value;
                  setPatientDetails(temp);
                  setReload(new Date());
                }}
                value={patientDetails.phone}
              />
            </Grid>
          </Grid>
        </div>
        <Grid
          container
          style={{ marginTop: 15, flex: 1, flexDirection: "row" }}
        >
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            style={{
              padding: 8,
              alignItems: "center",
              flex: 1,
              textAlign: "center",
            }}
          >
            <Button
              color="primary"
              onClick={() => {
                setBirthYear("");
                setNationalCode("");
                setPatientName("");
                setPatientFamily("");
                setPatientDetails({
                  gender: "",
                  age: "",
                  weight: "",
                  height: "",
                  phone: "",
                });
                setPatientExist(true);

                closeHandle();
              }}
            >
              {getText("cancel", "fa")}
            </Button>
          </Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            style={{
              padding: 8,
              alignItems: "center",
              flex: 1,
              textAlign: "center",
            }}
          ></Grid>
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            style={{
              padding: 8,
              alignItems: "center",
              flex: 1,
              textAlign: "center",
            }}
          >
            <Button
              color="primary"
              onClick={() => {
                if (controller.id.length < 10 && nationalCode.length > 0) {
                  Swal.fire({
                    title: getText("warning", "fa"),
                    text: getText("firstregister", "fa"),
                    confirmButtonText: getText("ok", "fa"),
                  });

                  return;
                }
                startPage();
              }}
            >
              {getText("continue", "fa")}
            </Button>
          </Grid>
        </Grid>
        <Drawer
          anchor="bottom"
          variant="persistent"
          style={{ maxHeight: 300 }}
          open={true}
          onClose={() => setNationalCodeList([])}
        >
          <List autoFocus={false}>
            {nationalCodeList &&
              nationalCodeList.map((item, index) => (
                <ListItem
                  key={item.id}
                  button
                  onClick={() => {
                    setNationalCode(item.patientNationalCode);
                    processNationalCode(item.patientNationalCode);
                    setFocus("birthyear");
                    setNationalCodeList([]);
                    closeHandle();
                  }}
                >
                  {/* <SaveOutlinedIcon style={{ color: "#039dfc", paddingRight: 5 }} /> */}
                  <ListItemText primary={item.patientNationalCode} />
                </ListItem>
              ))}
          </List>
        </Drawer>
      </LoadingOverlay>
    </div>
  );
}
